import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import 'rxjs/add/operator/map';
import { shareReplay, map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import 'async';
import { PresignedResponse } from "../models/presignedUrl.model";

// Models
import { RESTModel } from '../models/rest.model';

// Other
import { API_SERVER } from '../configs/constants.config';
@Injectable()
export class DataService {
  protected apiURL: string = API_SERVER.protocol + '://' + API_SERVER.ip + API_SERVER.startpoint;
  protected authToken: string;
  currentUserId;

  constructor(
    public http: HttpClient,
    public authService: NbAuthService) {
    this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
      if (token) {
        this.authToken = token.getValue();
        const JWTToken = new NbAuthJWTToken(token.getValue());
        //JWTToken.setValue(token.getValue());
        const tokenPayload = JWTToken.getPayload();
        this.currentUserId = tokenPayload.id;
      }
    });
  }

  private getHttpOptions() {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: this.authToken,
    });
    const options = { headers: headers };
    return options;
  }

    public dataPolices(id: any) {
        return this.http.get(`${this.apiURL}/dataClaim/users/${this.currentUserId}/showSiniestroAlert/${id}`, this.getHttpOptions());
    }

    public dataSucursal() {
      return this.http.get(`${this.apiURL}/users/${this.currentUserId}/projects/v2/mysucursals`, this.getHttpOptions());
  }

    public dataAlerts(id: number, input: string, typeSearch: string) {

        let query = '';

        if(input !== ''){

          query = '&search=' + input;

          switch(typeSearch) {
            case '1':
                query = query + '&searchColumn=siniestroNum';
            break;
            case '2':
                query = query + '&searchColumn=policyNum';
            break;
            case '3':
                query = query + '&searchColumn=asegurado';
            break;
            case '4':
                query = query + '&searchColumn=municipio';
            break;
            case '5':
                query = query + '&searchColumn=causa';
            break;
            case '6':
                query = query + '&searchColumn=beneficiary';
            break;
          }
        }

        let ciclo = localStorage.getItem('alertas_ciclo');
        let season:any = 1;

        if(ciclo){
          season = ciclo;
        }

        return this.http.get(`${this.apiURL}/datashow/user/${id}/misalertashow?season=${season}${query}`, this.getHttpOptions())
    }

    public usersAlert(projectid: number) {
        return this.http.get(`${this.apiURL}/datapull/project/${projectid}/showusers`, this.getHttpOptions())
    }
    
		public getResetHistory(claimId: number) {
        return this.http.get(`${this.apiURL}/dataClaim/historicResetClaim/${claimId}`, this.getHttpOptions())
    }

		public getHistoryFiles(claimId: number) {
				return this.http.get(`${this.apiURL}/ResetClaims/${claimId}`, this.getHttpOptions())
		}

		public updateAlert(claimId: number, body) {
			return this.http.put(`${this.apiURL}/dataClaim/editclaim/${claimId}`, body, this.getHttpOptions())
		}

		public resetAlert(claimId: number, params) {
			return this.http.put(`${this.apiURL}/dataClaim/resetclaim/${claimId}${params}`, {}, this.getHttpOptions())
		}
		
		public requestResetAlert(body) {
			return this.http.post(`${this.apiURL}/ResetClaims/peticion`, body, this.getHttpOptions())
		}

		public shownPendingResetAlert(claimId: number, query: string) {
			return this.http.get(`${this.apiURL}/ResetClaims/${claimId}?${query}`, this.getHttpOptions())
		}
		
		public requestReview(body) {
			return this.http.post(`${this.apiURL}/ResetClaims/revision`, body, this.getHttpOptions())
		}

		public saveFormats(body) {
			return this.http.post(`${this.apiURL}/ResetClaims`, body, this.getHttpOptions())
		}

		public saveFormats2(body) {
			return this.http.post(`${this.apiURL}/ResetClaims/createResetFormats`, body, this.getHttpOptions())
		}

		public getSignedUrls(body): Observable<PresignedResponse> {
			return this.http.post<PresignedResponse>('https://staging.sinecta.com/api/s3/sign-batch', body, this.getHttpOptions())
		}

		public uploadFileToSignedUrl(signedUrl: string, file: Blob) {
			return this.http.put(signedUrl, file, {
				headers: new HttpHeaders({
					'Content-Type': 'application/pdf',
				}),
			});
		}
}
